module.exports = __webpack_public_path__ + "static/media/eye.f0cd9b42.svg";